import { MoreHorizontal } from "lucide-react";
import OverrideIndicator from "./OverrideIndicator";

interface DetailViewTriggerProps {
  entityId: string;
  inputType: string;
  onClick: (id: string, type: string) => void;
  hasOverride?: boolean;
  title?: string;
}

export default function DetailViewTrigger({
  entityId,
  inputType,
  onClick,
  hasOverride,
  title,
}: DetailViewTriggerProps) {
  const button = (
    <button
      type="button"
      onClick={() => onClick(entityId, inputType)}
      className="relative p-1.5 rounded-lg text-bark-400 hover:text-bark-700 hover:bg-grove-100 transition-colors"
      title={title ?? "Open detail view"}
    >
      <MoreHorizontal className="w-4 h-4" />
      {hasOverride && <OverrideIndicator show />}
    </button>
  );

  return button;
}
